import Loadable from 'my-components/Loadable';

import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';

export { EDITOR_PLUGINS } from './constants';

export default Loadable(() => import(/* webpackChunkName: "online-course-question" */ './OnlineCourseQuestion'), {
  fallback: (
    <>
      <Skeleton width={160} />
      <Skeleton height={130} my={1} variant="rectangular" width="100%" />
      <div style={{ textAlign: 'right' }}>
        <Button color="primary" size="small" variant="outlined">
          Reply
        </Button>
      </div>
    </>
  ),
});
